import { IMedicationCoSoItemRequest } from "../../../models/request/y-te/yTeRequests";
import { medication, MedicationCoSoItemResponse } from "../../../models/response/y-te/medication";
import {
	eMedicationActionTypeIds,
	IMedicationChangeDangKyDatas,
	IMedicationChangeSelectedIds,
	IMedicationCloseConfirm,
	IMedicationCloseDangKyModal,
	IMedicationCloseDetail,
	IMedicationDeleteErr,
	IMedicationDeleteStart,
	IMedicationDeleteSuccess,
	IMedicationLoadDangKyErr,
	IMedicationLoadDangKyStart,
	IMedicationLoadDangKySuccess,
	IMedicationLoadDetailErr,
	IMedicationLoadDetailStart,
	IMedicationLoadDetailSuccess,
	IMedicationLoadErr,
	IMedicationLoadStart,
	IMedicationLoadSuccess,
	IMedicationSaveDangKyErr,
	IMedicationSaveDangKyStart,
	IMedicationSaveDangKySuccess,
	IMedicationSaveErr,
	IMedicationSaveStart,
	IMedicationSaveSuccess,
	IMedicationShowConfirm,
	IMedicationShowDangKyModal,
	IMedicationShowDetail
} from "../../action-types/y-te/IMedicationActionTypes";

export const medicationActions = {
	loadMedicationStart: (dm_coso_id: number): IMedicationLoadStart => {
		return {
			type: eMedicationActionTypeIds.LOAD_START,
			payload: dm_coso_id
		}
	},
	loadMedicationSuccess: (data: MedicationCoSoItemResponse[]): IMedicationLoadSuccess => {
		return {
			type: eMedicationActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadMedicationError: (message: string): IMedicationLoadErr => {
		return {
			type: eMedicationActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadMedicationDetailStart: (id: number): IMedicationLoadDetailStart => {
		return {
			type: eMedicationActionTypeIds.LOAD_DETAIL_START,
			payload: id
		}
	},
	loadMedicationDetailSuccess: (data: medication): IMedicationLoadDetailSuccess => {
		return {
			type: eMedicationActionTypeIds.LOAD_DETAIL_SUCCESS,
			payload: data
		}
	},
	loadMedicationDetailError: (message: string): IMedicationLoadDetailErr => {
		return {
			type: eMedicationActionTypeIds.LOAD_DETAIL_ERROR,
			payload: message
		}
	},
	showMedicationDetail: (data?: medication): IMedicationShowDetail => {
		return {
			type: eMedicationActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeMedicationDetail: (): IMedicationCloseDetail => {
		return {
			type: eMedicationActionTypeIds.CLOSE_DETAIL
		}
	},
	changeMedicationSelectedIds: (ids: number[]): IMedicationChangeSelectedIds => {
		return {
			type: eMedicationActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	showMedicationConfirm: (): IMedicationShowConfirm => {
		return {
			type: eMedicationActionTypeIds.SHOW_CONFIRM
		}
	},
	closeMedicationConfirm: (): IMedicationCloseConfirm => {
		return {
			type: eMedicationActionTypeIds.CLOSE_CONFIRM
		}
	},
	saveMedicationStart: (data: medication): IMedicationSaveStart => {
		return {
			type: eMedicationActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveMedicationSuccess: (is_update: boolean): IMedicationSaveSuccess => {
		return {
			type: eMedicationActionTypeIds.SAVE_SUCCESS,
			payload: is_update
		}
	},
	saveMedicationError: (message: string): IMedicationSaveErr => {
		return {
			type: eMedicationActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	deleteMedicationStart: (id: number): IMedicationDeleteStart => {
		return {
			type: eMedicationActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteMedicationSuccess: (): IMedicationDeleteSuccess => {
		return {
			type: eMedicationActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteMedicationError: (message: string): IMedicationDeleteErr => {
		return {
			type: eMedicationActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	showMedicationDangKyModal: (): IMedicationShowDangKyModal => {
		return {
			type: eMedicationActionTypeIds.SHOW_DANGKY_MODAL
		}
	},
	closeMedicationDangKyModal: (): IMedicationCloseDangKyModal => {
		return {
			type: eMedicationActionTypeIds.CLOSE_DANGKY_MODAL
		}
	},
	loadMedicationDangKyStart: (dm_coso_id: number): IMedicationLoadDangKyStart => {
		return {
			type: eMedicationActionTypeIds.LOAD_DANGKY_START,
			payload: dm_coso_id
		}
	},
	loadMedicationDangKySuccess: (data: MedicationCoSoItemResponse[]): IMedicationLoadDangKySuccess => {
		return {
			type: eMedicationActionTypeIds.LOAD_DANGKY_SUCCESS,
			payload: data
		}
	},
	loadMedicationDangKyError: (message: string): IMedicationLoadDangKyErr => {
		return {
			type: eMedicationActionTypeIds.LOAD_DANGKY_ERROR,
			payload: message
		}
	},
	changeMedicationDangKyDatas: (data: MedicationCoSoItemResponse[]): IMedicationChangeDangKyDatas => {
		return {
			type: eMedicationActionTypeIds.CHANGE_DANGKY_DATAS,
			payload: data
		}
	},
	saveMedicationDangKyStart: (request: IMedicationCoSoItemRequest): IMedicationSaveDangKyStart => {
		return {
			type: eMedicationActionTypeIds.SAVE_DANGKY_START,
			payload: request
		}
	},
	saveMedicationDangKySuccess: (): IMedicationSaveDangKySuccess => {
		return {
			type: eMedicationActionTypeIds.SAVE_DANGKY_SUCCESS
		}
	},
	saveMedicationDangKyError: (message: string): IMedicationSaveDangKyErr => {
		return {
			type: eMedicationActionTypeIds.SAVE_DANGKY_ERROR,
			payload: message
		}
	}
}
